<template>
  <el-config-provider :locale="currentLocale" :size="elSize">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElConfigProvider } from 'element-plus';
import vi from 'element-plus/es/locale/lang/vi';
import en from 'element-plus/es/locale/lang/en';

const { locale } = useI18n();

const currentLocale = computed(() => (locale.value === 'vi' ? vi : en));
const elSize = 'default';
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}
</style>
